import React from 'react';

const AddProject = ({ width = '16', height = '16', className, ...rest }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      {...rest}
    >
      <path
        d="M12.3346 6.66536V4.66536L9.0013 1.33203H3.0013C2.64768 1.33203 2.30854 1.47251 2.05849 1.72256C1.80844 1.9726 1.66797 2.31174 1.66797 2.66536V13.332C1.66797 13.6857 1.80844 14.0248 2.05849 14.2748C2.30854 14.5249 2.64768 14.6654 3.0013 14.6654H5.66797"
        stroke="#6E7781"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33203 1.33203V3.9987C8.33203 4.35232 8.47251 4.69146 8.72256 4.94151C8.9726 5.19156 9.31174 5.33203 9.66536 5.33203H12.332"
        stroke="#6E7781"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.66536 9.33203C9.31174 9.33203 8.9726 9.47251 8.72256 9.72256C8.47251 9.9726 8.33203 10.3117 8.33203 10.6654"
        stroke="#6E7781"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.332 9.33203C12.6857 9.33203 13.0248 9.47251 13.2748 9.72256C13.5249 9.9726 13.6654 10.3117 13.6654 10.6654"
        stroke="#6E7781"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.332 14.6654C12.6857 14.6654 13.0248 14.5249 13.2748 14.2748C13.5249 14.0248 13.6654 13.6857 13.6654 13.332"
        stroke="#6E7781"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.66536 14.6654C9.31174 14.6654 8.9726 14.5249 8.72256 14.2748C8.47251 14.0248 8.33203 13.6857 8.33203 13.332"
        stroke="#6E7781"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AddProject;
